// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../configs/constant';

const listTingkat = [
    { id: 1, nama: 1 },
    { id: 2, nama: 2 },
    { id: 3, nama: 3 },
    { id: 4, nama: 4 },
    { id: 5, nama: 5 },
    { id: 6, nama: 6 },
    { id: 7, nama: 7 },
    { id: 8, nama: 8 },
    { id: 9, nama: 9 }
]

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    // ** State
    const [valDivisi, setValDivisi] = useState<any>(null)
    const [listDivisi, setListDivisi] = useState<any[]>([])

    const [valProfitCenter, setValProfitCenter] = useState<any>(null)
    const [listProfitCenter, setListProfitCenter] = useState<any[]>([])

    const [valPayrollRumus, setValPayrollRumus] = useState<any>(null)
    const [listPayrollRumus, setListPayrollRumus] = useState<any[]>([])

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valHrJabatan, setValHrJabatan] = useState<any>(null)
    const [listHrJabatan, setListHrJabatan] = useState<any[]>([])

    useEffect(() => {
        getDoctag()
        getDivisi()
    }, [])

    const getDoctag = () => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: {
                    syscabang_id: cabang,
                    sysmenu_id: 43
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDoctag(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getDivisi = () => {
        const url = apiUrl.apiUrl + '/hr/divisi/list-combo/' + cabang
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDivisi(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getJabatan = (hrdivisi_id: any) => {
        const url = apiUrl.apiUrl + '/hr/jabatan/list-combo/' + cabang
        axios
            .get(url, {
                params: {
                    hrdivisi_id: hrdivisi_id
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListHrJabatan(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const navigate = useNavigate();

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        hrdivisi_id: any,
        kode_jabatan: any,
        nama_jabatan: any,
        tingkat: any,
        hrjabatan_id: any,
        accprofitcenter_id: any,
        hrpayroll_rumus_id: any,
        keterangan: any,
        estimasi_upah: any,
        jumlah_karyawan: any,
        budget_mingguan: any,
        is_borongan: any,
        usia_min: any,
        usia_max: any,
        pendidikan_min: any,
        jk: any,
    }

    const defaultValues = {
        syscabang_id: cabang
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })


    const handleChangeAutocompleteDivisi = (event: SyntheticEvent, newValue: any | null) => {
        setValue('hrdivisi_id', newValue?.id)

        getJabatan(newValue?.id)
        setValDivisi(newValue)
    }

    const handleChangeAutocompleteProfitCenter = (event: SyntheticEvent, newValue: any | null) => {
        setValue('accprofitcenter_id', newValue?.id)
        setValProfitCenter(newValue)
    }

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }

    const handleChangeAutocompletePayrollRumus = (event: SyntheticEvent, newValue: any | null) => {
        setValue('hrpayroll_rumus_id', newValue?.id)
        setValPayrollRumus(newValue)
    }

    const handleChangeAutocompleteHrJabatan = (event: SyntheticEvent, newValue: any | null) => {
        setValue('hrjabatan_id', newValue?.id)
        setValHrJabatan(newValue)
    }

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/hr/jabatan/add'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/hr/jabatan')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Master Jabatan
                    </Typography>
                    <Divider sx={{ m: 0 }} />

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Document Tag
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sysdoctag_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDoctag}
                                                options={listDoctag}
                                                id='sysdoctag_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDoctag}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Document Tag'
                                                        error={Boolean(errors.sysdoctag_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Divisi
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='hrdivisi_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDivisi}
                                                options={listDivisi}
                                                id='hrdivisi_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDivisi}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Divisi'
                                                        error={Boolean(errors.hrdivisi_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.hrdivisi_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Profit Center
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='accprofitcenter_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valProfitCenter}
                                                options={listProfitCenter}
                                                id='accprofitcenter_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteProfitCenter}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Profit Center'
                                                        error={Boolean(errors.accprofitcenter_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.accprofitcenter_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Perhitungan Payroll
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='hrpayroll_rumus_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valPayrollRumus}
                                                options={listPayrollRumus}
                                                id='hrpayroll_rumus_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompletePayrollRumus}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Perhitungan Payroll'
                                                        error={Boolean(errors.hrpayroll_rumus_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.hrpayroll_rumus_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                    Tingkat
                                </Typography>
                                <FormControl fullWidth>
                                    <InputLabel>Tingkat</InputLabel>
                                    <Controller
                                        name='tingkat'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Tingkat'
                                                value={value || ''}
                                                onChange={onChange}
                                                error={Boolean(errors.tingkat)}
                                            >
                                                {listTingkat.map((item, index) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.tingkat && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Atasan Jabatan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='hrjabatan_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valHrJabatan}
                                                options={listHrJabatan}
                                                id='hrjabatan_id'
                                                disabled={getValues('hrdivisi_id') == undefined ? true : false}
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteHrJabatan}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Atasan Jabatan'
                                                        error={Boolean(errors.hrjabatan_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.hrjabatan_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Kode Jabatan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode_jabatan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Kode Jabatan'
                                                error={Boolean(errors.kode_jabatan)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.kode_jabatan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Nama Jabatan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama_jabatan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nama Jabatan'
                                                error={Boolean(errors.nama_jabatan)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nama_jabatan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Jumlah Karyawan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='jumlah_karyawan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Jumlah Karyawan'
                                                type='number'
                                                error={Boolean(errors.jumlah_karyawan)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.jumlah_karyawan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Usia Min
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='usia_min'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Usia Min'
                                                type='number'
                                                error={Boolean(errors.usia_min)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.usia_min && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Usia Max
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='usia_max'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Usia Max'
                                                type='number'
                                                error={Boolean(errors.usia_max)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.usia_max && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                    Pendidikan Min
                                </Typography>
                                <FormControl fullWidth>
                                    <InputLabel>Pendidikan Min</InputLabel>
                                    <Controller
                                        name='pendidikan_min'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Pendidikan Min'
                                                value={value || ''}
                                                onChange={onChange}
                                                error={Boolean(errors.pendidikan_min)}
                                            >
                                                <MenuItem value={'SMA/SMK'}>
                                                    SMA/SMK
                                                </MenuItem>
                                                <MenuItem value={'D3'}>
                                                    D3
                                                </MenuItem>
                                                <MenuItem value={'S1/D4'}>
                                                    S1/D4
                                                </MenuItem>
                                                <MenuItem value={'S2'}>
                                                    S2
                                                </MenuItem>

                                            </Select>
                                        )}
                                    />
                                    {errors.pendidikan_min && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                    Jenis Kelamin
                                </Typography>
                                <FormControl sx={{}}>
                                    {/* <FormLabel>Jenis Kelamin</FormLabel> */}
                                    <Controller
                                        name='jk'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => {
                                            return (
                                                <RadioGroup row value={value} onChange={onChange}>
                                                    <FormControlLabel value='L' control={<Radio />} label='Laki-laki' />
                                                    <FormControlLabel value='P' control={<Radio />} label='Perempuan' />
                                                    {/* <FormControlLabel value='L/P' control={<Radio />} label='Laki-laki & Perempuan' /> */}
                                                </RadioGroup>
                                            )
                                        }}
                                    />
                                    {errors.jk && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                                    Estimasi Upah
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='estimasi_upah'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => {
                                            return (
                                                <TextField
                                                    fullWidth
                                                    label='Estimasi Upah'
                                                    name='estimasi_upah'
                                                    value={
                                                        value !== undefined && value !== null && value !== ''
                                                            ? (() => {
                                                                // Format value for display: replace dot with comma, add thousand separator
                                                                const str = String(value).replace('.', ',')
                                                                const [integer, decimal] = str.split(',')
                                                                let formatted = integer ? Number(integer).toLocaleString('id-ID') : ''
                                                                if (decimal !== undefined) {
                                                                    formatted += ',' + decimal
                                                                }
                                                                return formatted
                                                            })()
                                                            : ''
                                                    }
                                                    onChange={e => {
                                                        let input = e.target.value

                                                        // Remove all except digits and comma
                                                        input = input.replace(/[^0-9,]/g, '')

                                                        // Split integer and decimal part
                                                        const [intPart, decimalPart] = input.split(',')

                                                        // Format integer part with thousand separator
                                                        let formatted = ''
                                                        if (intPart) {
                                                            const parsed = parseInt(intPart, 10)
                                                            formatted = isNaN(parsed) ? '' : parsed.toLocaleString('id-ID')
                                                        }
                                                        if (decimalPart !== undefined) {
                                                            formatted += ',' + decimalPart
                                                        }

                                                        // Raw value for backend: replace comma with dot
                                                        const rawValue = decimalPart !== undefined ? `${intPart}.${decimalPart}` : intPart

                                                        setValue('estimasi_upah', rawValue)
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{ inputMode: 'decimal' }}
                                                />
                                            )
                                        }}
                                    />
                                    {errors.estimasi_upah && (
                                        <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Keterangan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                rows={2}
                                                multiline
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    )
}
